// Ordenar la tabla de Tareas tocando el nombre de la columna.
//
// Lissette, 2026-08-21: escogio "Creación" en el selector de fecha y la lista
// no cambio de orden. Ese selector solo decide a QUE fecha se aplican Desde y
// Hasta — no ordena, y sin rango puesto no hace absolutamente nada. Lo que
// ella queria es lo que pidio en la misma frase: "en el nombre de la columna
// poder filtros".
//
// Esto vive en un modulo PLANO y no dentro de TasksView.jsx a proposito: asi
// las pruebas lo importan y ordenan listas de verdad, en vez de mirar el texto
// del archivo. Un .jsx importado desde las pruebas tumba el despliegue entero
// (regla de oro 48).

import { compararValores, siguienteOrden } from './ordenDeTabla.js';

// Las columnas de la tabla, en el mismo orden en que se pintan.
export function columnasTareas(es) {
  return [
    { key: 'title', label: es ? 'Título' : 'Title' },
    { key: 'type', label: es ? 'Tipo' : 'Type' },
    { key: 'priority', label: es ? 'Prioridad' : 'Priority' },
    { key: 'status', label: es ? 'Estado' : 'Status' },
    { key: 'assignee', label: es ? 'Asignado a' : 'Assigned to' },
    { key: 'reassigned', label: es ? 'Reasignado a' : 'Reassigned to' },
    { key: 'createdBy', label: es ? 'Creado por' : 'Created by' },
    { key: 'created', label: es ? 'Creado' : 'Created' },
    { key: 'due', label: es ? 'Vence' : 'Due' },
    { key: 'notes', label: es ? 'Notas' : 'Notes' },
    { key: 'activity', label: es ? 'Actividad' : 'Activity' },
    { key: 'completedBy', label: es ? 'Completado por' : 'Completed by' },
  ];
}

// El valor por el que ordena cada columna. Texto o numero, nunca null: la
// cadena vacia es la marca de "sin dato" que lee el comparador.
//
// `ctx.typeLabel` lo pone la vista, que es quien sabe resolver un tipo
// personalizado de la agencia. Asi este modulo no arrastra nada de React.
export function valorDeOrden(task, key, ctx) {
  const { users, actSummary, customStatuses, typeLabel } = ctx || {};
  const nombre = (id) => {
    const u = id ? (users || []).find((x) => x && x.id === id) : null;
    return u ? (u.name || '').toLowerCase() : '';
  };
  switch (key) {
    case 'title': return (task.title || '').toLowerCase();
    case 'type': return task.category ? String((typeLabel ? typeLabel(task.category) : task.category) || '').toLowerCase() : '';
    // Prioridad y estado se ordenan por IMPORTANCIA, no por alfabeto:
    // "Alta, Media, Baja" es util; "Alta, Baja, Media" no dice nada.
    case 'priority': return ({ high: 0, medium: 1, low: 2 })[task.priority] ?? 1;
    case 'status': return task.status === 'inprogress' ? 0
      : task.status === 'done' ? 3
      : (customStatuses || []).some((s) => s && s.id === task.status) ? 2 : 1;
    // La columna muestra el PRIMER responsable, no el actual: se ordena por lo
    // que se ve, que es lo unico que el usuario puede comprobar.
    case 'assignee': return nombre(task.firstAssignee || task.assignedTo);
    case 'reassigned': return (task.firstAssignee && task.assignedTo && task.firstAssignee !== task.assignedTo) ? nombre(task.assignedTo) : '';
    case 'createdBy': return nombre(task.createdBy);
    // Las fechas se comparan como texto ISO (2026-08-21...), que ya ordena
    // solo. Nada de new Date() ni toISOString(): eso corre el dia un puesto
    // para media America, y es un fallo que este repo ya ha tenido.
    case 'created': return String(task.createdAt || '');
    case 'due': return String(task.dueDate || '');
    // Cero notas es un dato, no un hueco: el 0 aqui SI ordena.
    case 'notes': return ((actSummary || {})[task.id] || {}).notes || 0;
    case 'activity': return ((actSummary || {})[task.id] || {}).events || 0;
    case 'completedBy': return nombre(task.completedBy);
    default: return '';
  }
}

export function compararPorColumna(a, b, key, dir, ctx) {
  return compararValores(valorDeOrden(a, key, ctx), valorDeOrden(b, key, ctx), dir, !!(ctx && ctx.es));
}

// El orden de siempre: en progreso arriba (lo accionable), completadas abajo,
// y dentro de cada grupo por prioridad. Se conserva como DESEMPATE de
// cualquier columna, y el tercer toque al encabezado vuelve a el.
export function ordenPorDefecto(a, b) {
  const sw = (s) => (s === 'inprogress' ? 0 : s === 'done' ? 2 : 1);
  if (sw(a.status) !== sw(b.status)) return sw(a.status) - sw(b.status);
  // `?? 1` y no `|| 1`: con `||` la prioridad alta (0) caia a 1 y quedaba
  // empatada con la media, asi que el segundo criterio no ordenaba nada.
  const o = { high: 0, medium: 1, low: 2 };
  return (o[a.priority] ?? 1) - (o[b.priority] ?? 1);
}

// El comparador completo que usa la vista.
export function comparadorDeTareas(sortBy, sortDir, ctx) {
  return (a, b) => {
    if (sortBy) {
      const r = compararPorColumna(a, b, sortBy, sortDir, ctx);
      if (r !== 0) return r;
    }
    return ordenPorDefecto(a, b);
  };
}

// `siguienteOrden` se sigue exportando desde aqui —TasksView lo importa de
// este modulo— pero vive en `ordenDeTabla.js`, compartido con Pagos del Mes.
export { siguienteOrden };
